"use strict";
exports.__esModule = true;
exports.getFutbalnetMatchDetailUrl = exports.getTeamName = exports.getTeamLogoSrc = exports.isRepreMatch = exports.getPpoLogoSrc = exports.getFlagUrl = exports.cleanRoundName = exports.getMatches = exports.getShootoutGoals = exports.getGoalsByMatchPart = exports.getSportSectorPhases = exports.getGoalsByTeams = exports.getTeamsIds = exports.getTeam = exports.TeamSide = exports.FALLBACK_LOGO_IMAGE = void 0;
var tslib_1 = require("tslib");
var format_1 = tslib_1.__importDefault(require("date-fns/format"));
var sportnet_utilities_1 = require("sportnet-utilities");
var CompetitionsApi_1 = tslib_1.__importDefault(require("../../../api/CompetitionsApi"));
var setupApis_1 = require("../../../api/setupApis");
setupApis_1.setupCompetitionsApi();
exports.FALLBACK_LOGO_IMAGE = '/content/crest.png';
var TeamSide;
(function (TeamSide) {
    TeamSide["HOME"] = "home";
    TeamSide["AWAY"] = "away";
})(TeamSide = exports.TeamSide || (exports.TeamSide = {}));
var getTeamIndex = function (teamSide) {
    switch (teamSide) {
        case TeamSide.HOME:
            return 0;
        case TeamSide.AWAY:
            return 1;
        default:
            return null;
    }
};
exports.getTeam = function (match, teamSide) {
    var _a, _b;
    if ((_a = match.teams) === null || _a === void 0 ? void 0 : _a.length) {
        var team = (match.teams || []).find(function (t) { var _a; return (((_a = t === null || t === void 0 ? void 0 : t.additionalProperties) === null || _a === void 0 ? void 0 : _a.homeaway) || '') === teamSide; });
        if (team) {
            return team;
        }
        else {
            var idx = getTeamIndex(teamSide);
            return idx ? (_b = match.teams[idx]) !== null && _b !== void 0 ? _b : null : null;
        }
    }
    return null;
};
exports.getTeamsIds = function (match) {
    var homeTeam = exports.getTeam(match, TeamSide.HOME);
    var homeTeamId = homeTeam ? homeTeam._id : match.teams[0]._id;
    var awayTeam = exports.getTeam(match, TeamSide.AWAY);
    var awayTeamId = awayTeam ? awayTeam._id : match.teams[1]._id;
    return { homeTeamId: homeTeamId, awayTeamId: awayTeamId };
};
exports.getGoalsByTeams = function (match) {
    var _a = exports.getTeamsIds(match), homeTeamId = _a.homeTeamId, awayTeamId = _a.awayTeamId;
    var homeTeamGoals = 0;
    var awayTeamGoals = 0;
    if (match.contumationScore && match.contumationScore.length) {
        homeTeamGoals = match.contumationScore[0];
        awayTeamGoals = match.contumationScore[1];
    }
    else if (match.score && match.score.length) {
        homeTeamGoals = match.score[0];
        awayTeamGoals = match.score[1];
    }
    else if (sportnet_utilities_1.getProp(match, ['protocol', 'events'], []).length) {
        homeTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
            if ((e.team === homeTeamId &&
                e.eventType === 'goal' &&
                e.type !== 'dropped' &&
                e.phase !== 'shootout') ||
                (e.team === awayTeamId &&
                    e.eventType === 'goal' &&
                    e.type === 'dropped')) {
                return acc + 1;
            }
            return acc;
        }, homeTeamGoals);
        awayTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
            if ((e.team === awayTeamId &&
                e.eventType === 'goal' &&
                e.type !== 'dropped' &&
                e.phase !== 'shootout') ||
                (e.team === homeTeamId &&
                    e.eventType === 'goal' &&
                    e.type === 'dropped')) {
                return acc + 1;
            }
            return acc;
        }, awayTeamGoals);
    }
    else if (match.protocol) {
        homeTeamGoals = match.protocol.events.reduce(function (acc, e) {
            if ((e.team === homeTeamId &&
                e.eventType === 'goal' &&
                e.phase !== 'shootout' &&
                e.type !== 'dropped') ||
                (e.team === awayTeamId &&
                    e.eventType === 'goal' &&
                    e.type === 'dropped')) {
                return acc + 1;
            }
            return acc;
        }, homeTeamGoals);
        awayTeamGoals = match.protocol.events.reduce(function (acc, e) {
            if ((e.team === awayTeamId &&
                e.eventType === 'goal' &&
                e.phase !== 'shootout' &&
                e.type !== 'dropped') ||
                (e.team === homeTeamId &&
                    e.eventType === 'goal' &&
                    e.type === 'dropped')) {
                return acc + 1;
            }
            return acc;
        }, awayTeamGoals);
    }
    return { homeTeamGoals: homeTeamGoals, awayTeamGoals: awayTeamGoals };
};
exports.getSportSectorPhases = function (sportSectorPhases, sport) {
    var phases = sportSectorPhases && (sportSectorPhases || []).find(function (i) { return i._id === sport; });
    return phases ? phases.items : [];
};
exports.getGoalsByMatchPart = function (match, sportSectorPhasesArr) {
    var _a = exports.getTeamsIds(match), homeTeamId = _a.homeTeamId, awayTeamId = _a.awayTeamId;
    var sportSectorPhases = exports.getSportSectorPhases(sportSectorPhasesArr, match.rules.sport_sector);
    return (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, event) {
        var _a, _b, _c, _d;
        if (event.eventType === 'goal') {
            var otherTeamId = event.team === homeTeamId ? awayTeamId : homeTeamId;
            if (event.type === 'dropped') {
                return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[event.phase] = tslib_1.__assign(tslib_1.__assign({}, (acc[event.phase] || {})), (_b = {}, _b[otherTeamId] = (acc[event.phase] ? acc[event.phase][otherTeamId] || 0 : 0) + 1, _b)), _a));
            }
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_c = {}, _c[event.phase] = tslib_1.__assign(tslib_1.__assign({}, (acc[event.phase] || {})), (_d = {}, _d[event.team] = (acc[event.phase] ? acc[event.phase][event.team] || 0 : 0) + 1, _d)), _c));
        }
        return acc;
    }, sportSectorPhases.reduce(function (acc, phase) {
        var _a, _b;
        if (sportnet_utilities_1.getProp(match, ['timer', phase._id, 'start', 'date'])) {
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[phase._id] = (_b = {},
                _b[homeTeamId] = 0,
                _b[awayTeamId] = 0,
                _b), _a));
        }
        return acc;
    }, {}));
};
exports.getShootoutGoals = function (match) {
    var _a = exports.getTeamsIds(match), homeTeamId = _a.homeTeamId, awayTeamId = _a.awayTeamId;
    var homeTeamGoals = 0;
    var awayTeamGoals = 0;
    if (sportnet_utilities_1.getProp(match, ['protocol', 'events'], []).length) {
        homeTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
            if (e.team === homeTeamId &&
                e.eventType === 'goal' &&
                e.phase === 'shootout') {
                return acc + 1;
            }
            return acc;
        }, homeTeamGoals);
        awayTeamGoals = (match.protocol ? match.protocol.events || [] : []).reduce(function (acc, e) {
            if (e.team === awayTeamId &&
                e.eventType === 'goal' &&
                e.phase === 'shootout') {
                return acc + 1;
            }
            return acc;
        }, awayTeamGoals);
    }
    else if (match.protocol) {
        homeTeamGoals = match.protocol.events.reduce(function (acc, e) {
            if (e.team === homeTeamId &&
                e.eventType === 'goal' &&
                e.phase === 'shootout') {
                return acc + 1;
            }
            return acc;
        }, homeTeamGoals);
        awayTeamGoals = match.protocol.events.reduce(function (acc, e) {
            if (e.team === awayTeamId &&
                e.eventType === 'goal' &&
                e.phase === 'shootout') {
                return acc + 1;
            }
            return acc;
        }, awayTeamGoals);
    }
    return { homeTeamGoals: homeTeamGoals, awayTeamGoals: awayTeamGoals };
};
/**
 * Returns matches of current month, defined by date in `date` input variable.
 *
 * @param widget Matches list widget data (dateFrom, dateTo is ignored)
 * @param date Date from which start and end of the month will be calculated.
 * @returns
 */
exports.getMatches = function (widget, loadMatchsParams) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var params, teamIds, matchesResponse;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {};
                if (widget.competitionId) {
                    params.competitionId = widget.competitionId;
                }
                if (widget.partId) {
                    params.partId = widget.partId;
                }
                if (widget.roundId) {
                    params.roundId = widget.roundId;
                }
                if (typeof widget.closed !== 'undefined') {
                    params.closed = widget.closed === 'true' ? true : false;
                }
                teamIds = tslib_1.__spreadArrays([widget.teamId], (widget.teamIds || [])).filter(Boolean);
                if (teamIds.length) {
                    params.teamIds = teamIds;
                }
                params.dateFrom = loadMatchsParams.dateFrom
                    ? format_1["default"](loadMatchsParams.dateFrom, 'yyyy-MM-dd')
                    : widget.dateFrom;
                params.dateTo = loadMatchsParams.dateTo
                    ? format_1["default"](loadMatchsParams.dateTo, 'yyyy-MM-dd')
                    : widget.dateTo;
                if (typeof widget.limit !== 'undefined') {
                    params.limit = widget.limit;
                }
                if (typeof loadMatchsParams.offset !== 'undefined') {
                    params.offset = loadMatchsParams.offset;
                }
                return [4 /*yield*/, CompetitionsApi_1["default"].getMatches(params)];
            case 1:
                matchesResponse = _a.sent();
                return [2 /*return*/, {
                        matches: matchesResponse.matches,
                        total: matchesResponse.total,
                        nextOffset: matchesResponse.nextOffset
                    }];
        }
    });
}); };
exports.cleanRoundName = function (roundName) {
    var stepOne = roundName.replace(/(\.){0,1}\s*kolo/g, '').trim();
    return isNaN(Number(stepOne)) ? stepOne : stepOne + ". kolo";
};
exports.getFlagUrl = function (country) {
    return country
        ? "https://api.sportnet.online/assets/countries/" + country.toUpperCase() + "_square.png"
        : exports.FALLBACK_LOGO_IMAGE;
};
exports.getPpoLogoSrc = function (_a) {
    var _id = _a._id;
    return _id
        ? "https://api.sportnet.online/data/ppo/" + _id + "/logo"
        : exports.FALLBACK_LOGO_IMAGE;
};
exports.isRepreMatch = function (appSpace) {
    return ['uefa', 'iihf'].includes(appSpace);
};
/**
 * Returns src of team logo. If match is "repre", returns flag of the country. If
 * it is match of home competition, returns team logo or PPO logo.
 *
 * @param matchAppSpace
 * @param team
 */
exports.getTeamLogoSrc = function (matchAppSpace, team) {
    if (!(team && team.organization)) {
        return exports.FALLBACK_LOGO_IMAGE;
    }
    return exports.isRepreMatch(matchAppSpace)
        ? exports.getFlagUrl(team.organization.country || '')
        : exports.getPpoLogoSrc(team.organization);
};
/**
 * Returns name of the team. In case of repre, returns name of the country.
 * Fo other competititons, returns name of the organisation.
 *
 * @param matchAppSpace
 * @param team
 */
exports.getTeamName = function (matchAppSpace, team) {
    var _a, _b;
    if (!team) {
        return '';
    }
    if (exports.isRepreMatch(matchAppSpace)) {
        return team.displayName || team.name;
    }
    return (_b = (_a = team.organization) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
};
exports.getFutbalnetMatchDetailUrl = function (issfId) {
    return "https://sportnet.sme.sk/futbalnet/z/sfz/zapas/" + issfId + "/";
};
